import { Component, Inject, OnInit, inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CreateUserValueOfPurchaseStrategyCommand } from 'src/app/core/api/models';
import { UserValueOfPurchaseStrategiesService } from 'src/app/core/api/services';
import {
  BaseFormModule,
  BaseFormPageComponent,
} from 'src/app/pages/shared/base';
import { ModalTitleComponent } from 'src/app/shared/global/modal-title/modal-title.component';

@Component({
  selector: 'app-value-of-purchase-strategies-form',
  styleUrls: ['./value-of-purchase-strategies-form.component.scss'],
  templateUrl: './value-of-purchase-strategies-form.component.html',
  imports: [BaseFormModule, ModalTitleComponent],
})
export class ValueOfPurchaseStrategiesFormComponent
  extends BaseFormPageComponent
  implements OnInit
{
  //#region Properties

  model: CreateUserValueOfPurchaseStrategyCommand = {};
  protected currentService = inject(UserValueOfPurchaseStrategiesService);
  //#endregion

  constructor(
    private dialogRef: MatDialogRef<ValueOfPurchaseStrategiesFormComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    super();
    this.formPageConfig.title = data?.title;
    this.formPageConfig.isEditMode = data?.isEdit;
    this.formPageConfig.editId = data?.id;
    if (data.model) this.model = data.model;
  }

  ngOnInit() {
    this.initForm();
  }

  ngAfterViewChecked(): void {
    this.cd.detectChanges();
  }

  initForm() {
    this.form = new FormGroup({
      title: new FormControl('', [Validators.required]),
    });
  }

  //#region Api

  //Create
  baseCreateApi(model: CreateUserValueOfPurchaseStrategyCommand) {
    this.loading = true;

    this.currentService
      .userValueOfPurchaseStrategiesCreate({ body: model })
      .pipe(this.basePipeOperators())
      .subscribe(this.baseObserver);
  }

  //#endregion

  onClose() {
    this.dialogRef.close();
  }

  onSuccess() {
    this.dialogRef.close(true);
    this.unSubs();
  }
}
